import useTranslations from '../../../hooks/useTranslations';
import './InputLink.scss';

const InputLink = () => {
  const { t } = useTranslations();
  return (
    <div className='description-container'>
      <span
        className='containerInputLink text-xs mx-2'
        dangerouslySetInnerHTML={{ __html: t('HOME_WARNING_LINK_ACCEPT_INVITATION') }}
      />
    </div>
  );
};

export default InputLink;
